module.exports = __webpack_public_path__ + "static/media/AW_rootbeer_hero_desktop_fr.6691c54e.jpg";